<template>
  <div class="draggable-box" :style="divStyle" @mousedown="startDrag">
    <div style="margin-bottom:10px;display:flex;justify-content: flex-end;">
      <div class="voice-input" v-if="showInput">
        {{ question }}
        <a-icon v-if="isTalking" type="loading" style="font-size:18px;color:#20aef4;margin-left:5px;" />
        <img v-else class="voice-img" :src="ImgVoice" alt="" />
      </div>
    </div>
    <div class="floatBox" v-if="visible" :style="boxStyle">
      <slot>
        <div class="default-content" :style="`--my-color: ${fontColor};--my-size: ${fontSize}px;`">
          <MarkDown v-if="resultText" :content="resultText"></MarkDown>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import MarkDown from '@/components/MarkDown'
import ImgVoice from '@/assets/voice.png'
export default {
  name: 'DraggableBox',
  components: {
    MarkDown
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    isTalking: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 200
    },
    height: {
      type: [Number, String],
      default: 150
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#1890ff'
    },
    type: {
      type: String,
      default: 'edit'
    },
    fontSize: {
      type: Number,
      default: 14
    },
    fontColor: {
      type: String,
      default: '#000000'
    },
    resultText: {
      type: String,
      default: ''
    },
    question: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      ImgVoice,
      position: { x: 0, y: 0 }, // y 现在表示距离底部的距离
      isDragging: false,
      startX: 0,
      startY: 0,
      startLeft: 0,
      startBottom: 0 // 改为 startBottom
    }
  },

  watch: {
    showInput: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.positionToBottomRight()
          })
        }
      }
    },
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.positionToBottomRight()
          })
        }
      }
    }
  },

  mounted() {
    this.addEventListeners()
  },

  beforeDestroy() {
    this.removeEventListeners()
  },

  methods: {
    addEventListeners() {
      document.addEventListener('mousemove', this.handleDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },

    removeEventListeners() {
      document.removeEventListener('mousemove', this.handleDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },

    positionToBottomRight() {
      const panel = document.querySelector('.drag-panel')
      if (panel) {
        const rect = panel.getBoundingClientRect()
        // const boxWidth = this.getBoxWidth()
        // const boxHeight = this.getBoxHeight()
        const dragElement = document.querySelector('.draggable-box')
        const height = dragElement.offsetHeight
        const width = dragElement.offsetWidth

        this.position = {
          x: (rect.width - width) / 2,
          y: (rect.height - height) / 2 // 距离底部 20px
        }
      } else {
        // 备用方案：定位到浏览器窗口右下角
        this.positionToWindowBottomRight()
      }
    },

    positionToWindowBottomRight() {
      // const boxWidth = this.getBoxWidth()
      // const boxHeight = this.getBoxHeight()
      const dragElement = document.querySelector('.draggable-box')
      const height = dragElement.offsetHeight
      const width = dragElement.offsetWidth
      this.position = {
        x: (window.innerWidth - width) / 2,
        y: (window.innerHeight - height) / 2 // 距离底部 20px
      }
    },

    getBoxWidth() {
      return typeof this.width === 'number' ? this.width : parseInt(this.width)
    },

    getBoxHeight() {
      return typeof this.height === 'number' ? this.height : parseInt(this.height)
    },

    // 修复的拖拽方法
    startDrag(event) {
      // 检查是否是关闭按钮
      if (event.target.closest('.close-btn')) {
        return
      }

      this.isDragging = true
      this.startX = event.clientX
      this.startY = event.clientY
      this.startLeft = this.position.x
      this.startBottom = this.position.y // 保存初始的 bottom 值

      // 阻止文本选择和默认行为
      event.preventDefault()
      event.stopPropagation()

      // 添加拖拽样式
      this.$el.style.cursor = 'grabbing'
      this.$el.style.zIndex = '1001'
    },

    handleDrag(event) {
      if (!this.isDragging) return

      const deltaX = event.clientX - this.startX
      const deltaY = event.clientY - this.startY

      // x 坐标正常计算
      this.position.x = this.startLeft + deltaX
      // y 坐标：因为使用 bottom 定位，鼠标向上移动时 bottom 应该增加
      this.position.y = this.startBottom - deltaY

      this.keepInBounds()
    },

    stopDrag() {
      if (!this.isDragging) return

      this.isDragging = false
      this.$el.style.cursor = 'move'
      this.$el.style.zIndex = '1000'
    },

    keepInBounds() {
      const panel = document.querySelector('.drag-panel')
      const boxWidth = this.getBoxWidth()
      const boxHeight = this.getBoxHeight()

      if (panel) {
        // 在指定容器内边界检测
        const rect = panel.getBoundingClientRect()

        // x 轴边界
        this.position.x = Math.max(0, Math.min(this.position.x, rect.width - boxWidth))
        // y 轴边界（bottom 不能小于 0，不能大于容器高度 - 盒子高度）
        this.position.y = Math.max(0, Math.min(this.position.y, rect.height - boxHeight))
      } else {
        // 在浏览器窗口内边界检测
        // x 轴边界
        this.position.x = Math.max(0, Math.min(this.position.x, window.innerWidth - boxWidth))
        // y 轴边界（bottom 不能小于 0，不能大于窗口高度 - 盒子高度）
        this.position.y = Math.max(0, Math.min(this.position.y, window.innerHeight - boxHeight))
      }
    }
  },

  computed: {
    boxStyle() {
      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
        maxHeight: typeof this.height === 'number' ? `${this.height}px` : this.height,
        backgroundColor: this.backgroundColor,
        border: `2px solid ${this.borderColor}`,
        fontSize: `${this.fontSize}px`,
        color: this.fontColor
      }
    },
    divStyle() {
      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width
        // left: `${this.position.x}px`,
        // bottom: `${this.position.y}px` // 使用 bottom 定位
      }
    }
  }
}
</script>

<style scoped lang="less">
.draggable-box {
  position: fixed;
  // cursor: move;
  user-select: none;
  z-index: 1000;
  /* 确保可以拖拽 */
  touch-action: none;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: fit-content;
  height: fit-content;
  margin: auto;
}
.floatBox {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
}
.floatBox::-webkit-scrollbar {
  width: 0;
}

.draggable-box:active {
  cursor: grabbing;
}

.default-content {
  width: 100%;
  height: 100%;
  padding: 20px;
  /* animation: scrollContent 10s linear infinite; */
  // padding-top: 100px;
}

.draggable-box::-webkit-scrollbar {
  width: 0;
}

.box-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.box-text {
  margin-bottom: 4px;
}

.box-hint {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  transition: background-color 0.2s ease;
  z-index: 10;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.2);
}

.close-btn {
  pointer-events: auto;
}

.voice-input {
  // width: 312px;
  background: #000a2bcc;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  font-weight: 400;
  font-size: 14px;
  color: #fff;
  border: 1px solid #82bcff;
  float: right;
  .voice-img {
    width: 17px;
    height: 23px;
    margin-left: 5px;
  }
}

::v-deep .markdown-container {
  color: var(--my-color) !important;
  font-size: var(--my-size) !important;
}
::v-deep .markdown-container * {
  font-size: var(--my-size) !important;
}
::v-deep .markdown-container.markdown-body table tr {
  background-color: unset !important;
}
::v-deep .markdown-container.markdown-body table tr:nth-child(2n) {
  background-color: unset !important;
}
@keyframes scrollContent {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
</style>
